import {
  APP_ACQUISITION_URL,
  copyAppLink,
  shareApp,
  shareResultMessage,
} from "@sportsmet/app-sharing";
import { Button, Card } from "@sportsmet/ui";
import { useState } from "react";

export function AppInvite() {
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const copy = async (text: string): Promise<boolean> => {
    await navigator.clipboard.writeText(text);
    return true;
  };
  async function act(mode: "share" | "copy") {
    setBusy(true);
    setMessage("");
    const result =
      mode === "copy"
        ? await copyAppLink(copy)
        : await shareApp({
            copy,
            share:
              typeof navigator.share === "function"
                ? async (payload) => {
                    await navigator.share(payload);
                    return "shared";
                  }
                : undefined,
          });
    setMessage(shareResultMessage(result));
    setBusy(false);
  }
  return (
    <Card>
      <div className="mx-auto flex w-full max-w-180 flex-col gap-4">
        <h2 className="text-h2">Grow the fanbase</h2>
        <p>
          Invite anyone to join Sportsmet for sports pools, scores, and friends.
        </p>
        <h3 className="text-h3">How it works</h3>
        <ol className="list-decimal pl-6">
          <li>Share your invite.</li>
          <li>Your friends join Sportsmet.</li>
          <li>Enjoy the games together.</li>
        </ol>
        <div className="flex flex-wrap gap-3">
          <Button disabled={busy} onClick={() => void act("share")}>
            Share invite
          </Button>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={() => void act("copy")}
          >
            Copy link
          </Button>
        </div>
        <a
          className="min-h-touch-target break-all text-primary underline"
          href={APP_ACQUISITION_URL}
        >
          {APP_ACQUISITION_URL}
        </a>
        <p role="status" aria-live="polite">
          {message}
        </p>
      </div>
    </Card>
  );
}
